"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.printCalendar = exports.getCalendarDateItem = exports.getDateCount = exports.getFebCount = exports.isLeapYear = exports.getNextMonthDate = exports.getPrevMonthDate = exports.getNextYear = exports.getNextMonth = exports.getPrevYear = exports.getPrevMonth = exports.toHumanDate = exports.CalendarPart = void 0;
var timeUnit_1 = require("./timeUnit");
var array_1 = require("./array");
var CalendarPart;
(function (CalendarPart) {
    CalendarPart["Head"] = "head";
    CalendarPart["Body"] = "body";
    CalendarPart["Tail"] = "tail";
})(CalendarPart = exports.CalendarPart || (exports.CalendarPart = {}));
/**
 * 获取人类可读的日期
 * @param d 日期
 */
function toHumanDate(d) {
    return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        date: d.getDate(),
        day: d.getDay(),
    };
}
exports.toHumanDate = toHumanDate;
function getPrevMonth(month) {
    return month === 1 ? 12 : month - 1;
}
exports.getPrevMonth = getPrevMonth;
function getPrevYear(month, year) {
    return month === 1 ? year - 1 : year;
}
exports.getPrevYear = getPrevYear;
function getNextMonth(month) {
    return month === 12 ? 1 : month + 1;
}
exports.getNextMonth = getNextMonth;
function getNextYear(month, year) {
    return month === 12 ? year + 1 : year;
}
exports.getNextYear = getNextYear;
/**
 * 通过传入日期取上/下一月对应时间
 * 2018.2.15 > 2018.1.15
 * @param d 时间
 */
function getPrevMonthDate(d) {
    var _a = toHumanDate(d), year = _a.year, month = _a.month, date = _a.date;
    var prevYear = getPrevYear(month, year);
    var prevMonth = getPrevMonth(month);
    var prevDateCount = getDateCount(prevYear, prevMonth);
    var prevDate = date > prevDateCount ? prevDateCount : date;
    return new Date(prevYear, prevMonth - 1, prevDate);
}
exports.getPrevMonthDate = getPrevMonthDate;
function getNextMonthDate(d) {
    var _a = toHumanDate(d), year = _a.year, month = _a.month, date = _a.date;
    var nextYear = getNextYear(month, year);
    var nextMonth = getNextMonth(month);
    var nextDateCount = getDateCount(nextYear, nextMonth);
    var nextDate = date > nextDateCount ? nextDateCount : date;
    return new Date(nextYear, nextMonth - 1, nextDate);
}
exports.getNextMonthDate = getNextMonthDate;
/**
 * 是否是闰年
 * @param year 年份
 */
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
exports.isLeapYear = isLeapYear;
/**
 * 二月天数
 * @param year 年份
 */
function getFebCount(year) {
    return isLeapYear(year) ? 29 : 28;
}
exports.getFebCount = getFebCount;
/**
 * 某月天数
 * @param year 年份
 * @param month 月份
 */
function getDateCount(year, month) {
    var month31 = [1, 3, 5, 7, 8, 10, 12];
    return month === 2
        ? getFebCount(year)
        : month31.indexOf(month) > -1
            ? 31
            : 30;
}
exports.getDateCount = getDateCount;
/**
 * 获取当月所有日期数据
 * @param d 时间对象
 * @param startAt 第一列是周日(0)还是周一(1)
 * @param count 总共输出多少天，默认: 49 = 7 * 7
 */
function getCalendarDateItem(d, startAt, count) {
    if (d === void 0) { d = new Date(); }
    if (startAt === void 0) { startAt = 0; }
    if (count === void 0) { count = 49; }
    if (startAt !== 0 && startAt !== 1)
        console.warn("[startAt] should 0 or 1");
    var currMS = d.getTime();
    var currDate = new Date(currMS);
    var oneDayMS = timeUnit_1.TimeUnit.Day;
    var currMonth = currDate.getMonth();
    var dateCount = getDateCount(d.getFullYear(), currMonth);
    currDate.setDate(1);
    var firstDayMS = currDate.getTime();
    var lastDayMS = firstDayMS + dateCount * oneDayMS;
    var startCol = currDate.getDay() - startAt;
    var startMS = firstDayMS - startCol * oneDayMS;
    return array_1.makeArray(count).map(function (index) {
        var ms = startMS + index * oneDayMS;
        var d = new Date(ms);
        var key = ms < firstDayMS
            ? CalendarPart.Head
            : (ms > lastDayMS ? CalendarPart.Tail : CalendarPart.Body);
        var date = toHumanDate(d);
        return __assign({ key: key }, date);
    });
}
exports.getCalendarDateItem = getCalendarDateItem;
// 打印日历
function printCalendar(d, startAt, count) {
    if (d === void 0) { d = new Date(); }
    if (startAt === void 0) { startAt = 0; }
    var items = getCalendarDateItem(d, startAt, count);
    var logs = [];
    console.log("\n");
    items.forEach(function (item) {
        var str = item.date.toString().length === 1
            ? " " + item.date
            : "" + item.date.toString();
        logs.push(str);
        if (logs.length === 7) {
            console.log(logs.join(" "));
            logs = [];
        }
    });
    console.log("\n");
}
exports.printCalendar = printCalendar;
